<template>
  <v-chip :color="display.color" small>
    {{ display.label }}
    <v-tooltip v-if="display.tooltip" activator="parent" location="bottom">
      {{ display.tooltip }}
    </v-tooltip>
  </v-chip>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from 'vue-i18n'

import { getCalculationStatusDisplay } from '@/utils/calculationStatus.ts'

const props = defineProps<{ status: string }>()

const { t } = useI18n()
const display = computed(() => getCalculationStatusDisplay(props.status, t))
</script>
